import React from "react";
import { Icon } from "../UIElements/Icon";
import LoyaltyCard from "./LoyaltyCard";

const LoyaltyPointsTab = ({ loyaltyLevel }) => {
  if (!loyaltyLevel) {
    return (
      <div className="space-y-6">
        <div className="py-12 text-center">
          <Icon name="Star" className="mx-auto mb-4 h-12 w-12 text-gray-400" />
          <h3 className="mb-2 text-lg font-semibold text-white">
            No Loyalty Level Found
          </h3>
          <p className="text-gray-400">
            This user doesn&apos;t have a loyalty level assigned.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6">
        <LoyaltyCard loyaltyLevel={loyaltyLevel} />
      </div>
    </div>
  );
};

export default LoyaltyPointsTab;
